<template>
    <div data-view="bookings">
        <base-header type="gradient-perso" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <bookings-table title="Buchungen" :startPagination="startPagination" :startSearch="startSearch" :startSorting="startSorting"></bookings-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BookingsTable from './Tables/BookingsTable'
import userSettings from '@/userSettings'

export default {
    name: 'bookings',
    components: {
        BookingsTable
    },
    props: {
        pagination: {
            type: Object,
            default() {
                return {
                    showAll: false,
                    total: 0,
                    perPage: userSettings.getSetting('rowsPerTable'),
                    value: 1,
                };
            },
        },
        search: {
            type: Object,
            default() {
                return {
                    booker_name: '',
                    booker_hotelname: '',
                    decision: '',
                    created_at: '',
                };
            },
        },
        sorting: {
            type: Object,
            default() {
                return {
                    field: 'created_at',
                    dir: 'desc',
                };
            },
        },
    },
    data() {
        return {
            startPagination: this.pagination,
            startSearch: this.search,
            startSorting: this.sorting,
        };
    },
};
</script>
<style></style>
